/* OV Store — popup del lead magnet "Vela Ignorada".
   Vanilla, sin dependencias, sin llamadas a terceros. El envío lo hace el form nativo
   de Shopify (`form 'customer'`), que recarga la página con ?customer_posted=true.

   Reglas de aparición (valores reales en los data-* que escribe la sección):
     - Nunca antes de `delay` segundos de estar en la página.
     - Luego, lo que ocurra primero: llegar al `scroll`% de la página, cumplir `dwell`
       segundos, o intentar salir por arriba con el ratón (solo puntero fino).
     - Nunca dos veces en la misma sesión, ni si ya se suscribió, ni durante los
       `snooze` días siguientes a cerrarlo.
     - En la portada se retira si el visitante llega a la sección inline de la guía:
       la oferta ya está delante de él, pedirla otra vez sobra.
     - No se abre solo dentro del editor de temas.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-guide-popup]');
  if (!root) return;

  var DONE = 'ov_guide_done';       // se suscribió: no volver a mostrar
  var SNOOZE = 'ov_guide_snooze';   // lo cerró: pausa de N días
  var PENDING = 'ov_guide_pending'; // envió desde el popup, esperando la recarga
  var SESSION = 'ov_guide_shown';   // ya se mostró en esta sesión

  function readCookie(name) {
    return document.cookie.split('; ').some(function (c) { return c.indexOf(name + '=') === 0; });
  }
  function writeCookie(name, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function dropCookie(name) {
    document.cookie = name + '=; Max-Age=0; path=/; SameSite=Lax';
  }
  function session(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key) === '1';
      sessionStorage.setItem(key, '1');
    } catch (e) { /* modo privado: se degrada a las cookies */ }
    return false;
  }

  var num = function (attr, fallback) {
    var v = parseInt(root.getAttribute(attr), 10);
    return isNaN(v) ? fallback : v;
  };
  var delayMs = num('data-delay', 6) * 1000;
  var scrollPct = num('data-scroll', 35);
  var dwellMs = num('data-dwell', 25) * 1000;
  var snoozeDays = num('data-snooze-days', 7);
  var exitIntent = root.getAttribute('data-exit-intent') === 'true';
  var designMode = root.getAttribute('data-design-mode') === 'true';

  var successState = root.querySelector('[data-gpop-success]');
  var panel = root.querySelector('.gpop__panel');
  var opener = null;
  var armed = false;
  var open = false;

  /* --- apertura / cierre ------------------------------------------------ */

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function show() {
    if (open) return;
    open = true;
    opener = document.activeElement;
    root.hidden = false;
    // Fuerza un reflow para que la transición de entrada tenga estado inicial.
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown, true);
    session(SESSION, true);
    var target = panel.querySelector('input[type="email"]') || panel.querySelector('[data-gpop-close]');
    if (target) target.focus({ preventScroll: true });
  }

  function close() {
    if (!open) return;
    open = false;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown, true);
    writeCookie(SNOOZE, snoozeDays);
    var hide = function () { root.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) hide();
    else window.setTimeout(hide, 260);
    if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-gpop-close]')) { e.preventDefault(); close(); }
  });

  /* --- estado de éxito tras la recarga ---------------------------------- */

  // El form nativo recarga con ?customer_posted=true. Solo reabrimos el popup si el
  // envío salió de aquí (cookie PENDING), no si vino del formulario del footer.
  if (successState) {
    if (readCookie(PENDING)) {
      dropCookie(PENDING);
      writeCookie(DONE, 365);
      dropCookie(SNOOZE);
      show();
    }
    return; // en esta carga no hay reglas de aparición que evaluar
  }

  var submit = root.querySelector('[data-gpop-submit]');
  if (submit) {
    submit.addEventListener('click', function () { writeCookie(PENDING, 1); });
  }

  /* --- reglas de aparición ---------------------------------------------- */

  if (designMode) return;
  if (readCookie(DONE) || readCookie(SNOOZE)) return;
  if (session(SESSION)) return;

  // En la portada, si el visitante alcanza la sección inline de la guía, el popup se retira.
  var inline = document.querySelector('[data-guide-inline]');
  var standDown = false;
  if (inline && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) {
        standDown = true;
        io.disconnect();
      }
    }, { threshold: 0.25 });
    io.observe(inline);
  }

  function trigger() {
    if (open || standDown) return;
    detach();
    show();
  }

  function onScroll() {
    if (!armed) return;
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    if ((window.scrollY / max) * 100 >= scrollPct) trigger();
  }
  function onMouseOut(e) {
    if (!armed) return;
    if (e.clientY <= 0 && !e.relatedTarget) trigger();
  }
  var dwellTimer = null;
  function detach() {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onMouseOut);
    if (dwellTimer) window.clearTimeout(dwellTimer);
  }

  window.setTimeout(function () {
    armed = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    if (exitIntent && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', onMouseOut);
    }
    dwellTimer = window.setTimeout(trigger, Math.max(dwellMs - delayMs, 0));
    onScroll(); // por si ya cargó con la página avanzada
  }, delayMs);
})();
